export enum OrderPaymentStatus {
  'None' = 'None',
  'Pending' = 'Pending',
  'Transferred' = 'Transferred',
  'Failed' = 'Failed',
  'Canceled' = 'Canceled'
}
